import { useEffect, useState } from "react";
import { Row, Col, Button, Card, Typography, Badge, Form, message, Grid, Input, Upload, Tooltip, Modal, Table, Space } from "antd";
import { InfoCircleOutlined, PlusOutlined, TagOutlined } from '@ant-design/icons';
import ViewPPTDetails from "./ViewPPTDetails";
import OfferDetails from "./OfferDetails";
import { useDispatch, useSelector } from "react-redux";
import HandwritingNotes from "./HandwritingNotes";
import TextArea from 'antd/es/input/TextArea';
import ExchangePrice from "./ExchangePrice";
import { TableWrapper } from "../../container/styled";
import ComparisonTable from "./ComparisonTable";
import { ResetFileUpload, uploadPdf } from "../../redux/exchange/actionCreator";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

function ViewPPTData({
    aboutInfoPPTDetailsData,
    comparissionTableData,
    setAutoStop,
    formData,
    setFormData,
    form,
    setLoader,
    setAutoResume,
    modelSubmit,
    setModelSubmit,
    setUploadedImages,
    uploadedImages,
    form2
}) {
    const dispatch = useDispatch()

    const stockDetails = aboutInfoPPTDetailsData.data.product_stock
    const imageUploaded = useSelector((state) => state.fileUpload.pdf);

    const [stockStatus, setStockStatus] = useState({});
    const [isOutOfStock, setIsOutOfStock] = useState(false);
    const [storeInfoModal, setStoreInfoModal] = useState(false);

    const { statusText, color, textColor, stores } = stockStatus || {};

    const screens = useBreakpoint();
    const isSmall = !screens.lg;

    function getStoreStatus(stockData) {
        if (stockData.status) {
            if (stockData.data["0KM"].length > 0) {
                setIsOutOfStock(false)
                return {
                    statusText: "In Stock",
                    color: "#008000",
                    textColor: "white",
                };
            } else if (stockData.data["0-3KM"].length > 0) {
                setIsOutOfStock(false)
                return {
                    color: "#caca16ff",
                    textColor: "black",
                    statusText: "Other Store",
                    stores: stockData.data["0-3KM"],
                };
            } else if (stockData.data["3-10KM"].length > 0) {
                setIsOutOfStock(false)
                return {
                    color: "#06069d",
                    textColor: "white",
                    statusText: "Other Store",
                    stores: stockData.data["3-10KM"],
                };
            } else if (stockData.data["10-20KM"].length > 0) {
                setIsOutOfStock(false)
                return {
                    color: "#06069d",
                    textColor: "white",
                    statusText: "Other Store",
                    stores: stockData.data["10-20KM"],
                };
            } else if (stockData.data["20-30KM"].length > 0) {
                setIsOutOfStock(false)
                return {
                    color: "#06069d",
                    textColor: "white",
                    statusText: "Other Store",
                    stores: stockData.data["20-30KM"],
                };
            } else if (stockData.data["30KM"].length > 0) {
                setIsOutOfStock(false)
                return {
                    color: "#06069d",
                    textColor: "white",
                    statusText: "Other Store",
                    stores: stockData.data["30KM"],
                };
            } else {
                setIsOutOfStock(true)
                return {
                    statusText: "Out of Stock",
                    color: "#980202",
                    textColor: "white",
                };
            }
        }
        setIsOutOfStock(true);
        return {
            statusText: "Out of Stock",
            color: "#980202",
            textColor: "white",
        };
    }

    const flipkartValidation = (rule, value) => {
        if (value) {
            const flipkartPattern = /^https?:\/\/(?:www\.)?flipkart\.com/;
            if (!flipkartPattern.test(value)) {
                return Promise.reject('Please enter a valid Flipkart link');
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const amazonValidation = (rule, value) => {
        if (value) {
            const amazonPattern = /^https?:\/\/(?:www\.)?amazon\.(in|com|co\.uk)/;
            if (!amazonPattern.test(value)) {
                return Promise.reject('Please enter a valid Amazon link');
            }

            return Promise.resolve();
        }
        return Promise.resolve();
    };
    const handleVariationSubmit = () => {
        form2.validateFields()
            .then(values => {
                const { image_upload, ...filteredValues } = values;
                const token = localStorage.getItem('sectionId');
                const payload = {
                    ...filteredValues,
                    model_id: aboutInfoPPTDetailsData?.data?.offer_details?.model_id,
                    token: token,
                    uploaded_images: uploadedImages
                };
                console.log("submitted data", payload);
                message.success("Data submitted successfully!");
                form2.resetFields();
                dispatch(ResetFileUpload())
                setUploadedImages([])
            })
            .catch(err => {
                console.log("Validation Failed:", err);
            });
    }

    const handleVideoUpload = (file) => {
        dispatch(uploadPdf(file, "about"));
        return false;
    };

    useEffect(() => {
        if (stockDetails) {
            const status = getStoreStatus(stockDetails);
            setStockStatus(status);
        }
    }, [stockDetails]);

    useEffect(() => {
        if (imageUploaded.data) {
            setUploadedImages(prev => {
                const imageUploadedData = new Set([...prev, imageUploaded.data]);
                console.log("imageUploadedData", imageUploadedData);
                return Array.from(imageUploadedData);
            });
        }
    }, [imageUploaded.data, setUploadedImages]);

    useEffect(() => {
        return () => {
            form2.resetFields();
            dispatch(ResetFileUpload())
            setUploadedImages([])
        }
    }, [])
    const showStockRibbon = statusText && statusText !== "Other Store";
    const stockCard = (
        <Card style={{ background: color, position: "relative" }}>
            {stores?.length > 0 && (
                <Tooltip title="View store-wise stock">
                    <Button
                        type="text"
                        icon={<InfoCircleOutlined />}
                        onClick={() => setStoreInfoModal(true)}
                        style={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 2,
                            color: textColor,
                        }}
                    />
                </Tooltip>
            )}
            <Row align="middle" style={{ justifyContent: "space-between" }} gutter={[12, 12]}>
                <Col span={24}>
                    <Title
                        level={5}
                        style={{
                            color: textColor,
                            margin: 0,
                            fontWeight: 600,
                            fontSize: "16px",
                            paddingRight: stores?.length > 0 ? "40px" : 0
                        }}
                    >
                        {aboutInfoPPTDetailsData?.data?.offer_details?.model_name} - 8 Month EMI - ₹
                        {aboutInfoPPTDetailsData?.data?.offer_details?.emi_amount} -
                        <span
                            style={{
                                fontWeight: "bolder",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                marginInline: "4px",
                            }}
                        >
                            MOP <TagOutlined style={{ fontSize: 16 }} /> ₹
                            {aboutInfoPPTDetailsData?.data?.offer_details?.model_price}
                        </span>
                    </Title>
                </Col>
            </Row>

            {isOutOfStock && (
                <Row style={{ marginTop: 8 }}>
                    <Col span={24}>
                        <p
                            style={{
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            This product is not available anywhere in Sangeetha. We have notified the purchase team.
                        </p>
                    </Col>
                </Row>
            )}
        </Card>
    );
    const RibbonCard = (
        <>
            {showStockRibbon ? (
                <Badge.Ribbon
                    text={<span style={{ color: textColor, fontSize: "16px", fontWeight: "600", padding: "4px 0", marginTop: 16 }}>{statusText}</span>}
                    style={{ backgroundColor: color, boxShadow: "0 4px 16px rgba(0, 0, 0, 0.4)", border: "1px solid black" }}
                >
                    {stockCard}
                </Badge.Ribbon>
            ) : stockCard}
            <br />
            {aboutInfoPPTDetailsData?.data?.check_document &&
                <ViewPPTDetails data={aboutInfoPPTDetailsData?.data?.check_document} modelId={aboutInfoPPTDetailsData?.data?.offer_details?.model_id} />
            }
            <HandwritingNotes
                setAutoStop={setAutoStop}
                formData={formData}
                setFormData={setFormData}
                form={form}
                setLoader={setLoader}
                setAutoResume={setAutoResume}
                modelSubmit={modelSubmit}
                setModelSubmit={setModelSubmit}
            />
        </>
    );
    const variationCard = (
        <Card style={{
            marginTop: 24,
            borderRadius: 24,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
            padding: 12
        }}>
            <Title level={5}>If any price variation from any online website please share the Details</Title>

            <Form layout="vertical" form={form2} onFinish={handleVariationSubmit}>
                <Form.Item
                    name="flipkart_link"
                    label={<Text strong>Flipkart Link</Text>}
                    rules={[
                        { validator: flipkartValidation }
                    ]}
                >
                    <Input placeholder='Enter Flipkart link' />
                </Form.Item>
                <Form.Item
                    name="amazon_link"
                    label={<Text strong>Amazon Link</Text>}
                    rules={[
                        { validator: amazonValidation }
                    ]}
                >
                    <Input placeholder='Enter Amazon link' />
                </Form.Item>
                <Form.Item
                    name="image_upload"
                    label={<Text strong>Upload Image</Text>}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => e?.fileList}
                    rules={[{ required: true, message: 'Please upload an image' }]}
                >
                    <Upload
                        beforeUpload={handleVideoUpload}
                        accept="image/*"
                        listType="picture-card"
                        showRemoveIcon={false}
                        onRemove={() => false}
                        style={{ width: "100%" }}
                    >
                        <div>
                            <PlusOutlined />
                            <div style={{ marginTop: 8 }}>Upload</div>
                        </div>
                    </Upload>
                </Form.Item>
                <Form.Item
                    name="description"
                    label={<Text strong>Description</Text>}
                    rules={[{ required: true, message: 'Please enter a description' }]}
                >
                    <TextArea placeholder='Enter description' />
                </Form.Item>

                <Form.Item style={{ margin: 0 }}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        </Card>


    )
    return (
        <Row gutter={[25, 25]} style={{ marginBottom: "20px" }}>
            <Modal
                title={`Available Stores`}
                open={storeInfoModal}
                onCancel={() => setStoreInfoModal(false)}
                footer={null}
                width={650}
                styles={{
                    body: {
                        height: 400,
                        overflowY: "auto",
                    },
                }}
            >
                <Table
                    dataSource={stores}
                    rowKey="store_code"
                    pagination={false}
                    columns={[
                        {
                            title: "Store Name",
                            dataIndex: "store_name",
                            key: "store_name",
                        },
                        {
                            title: "Distance (KM)",
                            dataIndex: "distance_km",
                            key: "distance_km",
                            render: (km) => `${km} KM`,
                        },
                        {
                            title: "Stock",
                            dataIndex: "qty",
                            key: "qty",
                            sorter: (a, b) => a.qty - b.qty,
                            defaultSortOrder: "descend",
                            render: (qty) => (
                                // <Badge
                                //     count={qty}
                                //     style={{
                                //         backgroundColor: qty > 0 ? "#52c41a" : "#f5222d"
                                //     }}
                                // />
                                <strong>{qty}</strong>
                            ),
                        },
                    ]}
                />
            </Modal>


            <Col xxl={16} lg={16} md={24} xs={24}>
                {aboutInfoPPTDetailsData?.data?.offer_details || aboutInfoPPTDetailsData?.data?.product_offers?.data ? (
                    <>
                        <OfferDetails
                            data={aboutInfoPPTDetailsData?.data?.offer_details}
                            offerListData={aboutInfoPPTDetailsData?.data?.product_offers?.data || []}
                        />

                        <br />
                    </>
                ) :
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                        <InfoCircleOutlined style={{ fontSize: 40, color: "#999" }} />
                        <h3 style={{ marginTop: 16, color: "#666" }}>
                            No offers available for this device
                        </h3>
                    </div>
                }
                {isSmall && RibbonCard}
                {aboutInfoPPTDetailsData?.data?.product_specification &&
                    comparissionTableData.length > 0 && (
                        <ComparisonTable data={comparissionTableData} />
                    )}
                {/* {isSmall && variationCard} */}
            </Col>

            <Col md={24} lg={8}>
                {!isSmall && <> {RibbonCard}
                    {/* {variationCard} */}
                </>}
            </Col>

        </Row >
    );
}

export default ViewPPTData;
